import { SCORE_METRIC_TYPES } from '../constants/Constants';
import { KEYS } from '../constants/SceneConstants';

export class GameShortcuts {
  constructor(game, shortcutcontroller, autoshow) {
    this._game = game;
    this._shortcutController = shortcutcontroller;
    shortcutcontroller.enable();
    this.addSuccessEndScreenShortcuts(game);
    this.addFailEndScreenShortcuts(game);
    if (autoshow) shortcutcontroller.show();
    else shortcutcontroller.hide();
    this._shortcutController.gui.domElement.style.width = '250px';
  }

  addSuccessEndScreenShortcuts(game) {
    this._shortcutController.addShortcutGroup({
      id: 'success_end_screens',
      group: 'success_end_screens',
      title: 'Success End Screens',
      open: false,
    });
    this._shortcutController.addShortcut({
      group: 'success_end_screens',
      field: 'public_opinion_success_screen',
      title: 'Public Opinion Success Screen',
      value: (e) => {
        this.setEndScreen({ type: SCORE_METRIC_TYPES.PUBLIC_OPINION, score: 100 });
      },
    });
    this._shortcutController.addShortcut({
      group: 'success_end_screens',
      field: 'stability_success_screen',
      title: 'Stability Success Screen',
      value: (e) => {
        this.setEndScreen({ type: SCORE_METRIC_TYPES.STABILITY, score: 100 });
      },
    });
    this._shortcutController.addShortcut({
      group: 'success_end_screens',
      field: 'credibility_success_screen',
      title: 'Credibility Success Screen',
      value: (e) => {
        this.setEndScreen({ type: SCORE_METRIC_TYPES.CREDIBILITY, score: 100 });
      },
    });
    this._shortcutController.addShortcut({
      group: 'success_end_screens',
      field: 'negotiation_success_screen',
      title: 'Negotiation Success Screen',
      value: (e) => {
        this.setEndScreen({ type: SCORE_METRIC_TYPES.NEGOTIATION, score: 100 });
      },
    });
    this._shortcutController.addShortcut({
      group: 'success_end_screens',
      field: 'multiple_success_screen',
      title: 'Multiple Success Screen',
      value: (e) => {
        this.setEndScreen({
          type: 'multiple',
          data: [
            { type: SCORE_METRIC_TYPES.NEGOTIATION, score: 100 },
            { type: SCORE_METRIC_TYPES.CREDIBILITY, score: 100 },
          ],
        });
      },
    });
  }

  addFailEndScreenShortcuts(game) {
    this._shortcutController.addShortcutGroup({
      id: 'failed_end_screens',
      group: 'failed_end_screens',
      title: 'Failed End Screens',
      open: false,
    });
    this._shortcutController.addShortcut({
      group: 'failed_end_screens',
      field: 'public_opinion_fail_screen',
      title: 'Public Opinion Fail Screen',
      value: (e) => {
        this.setEndScreen({ type: SCORE_METRIC_TYPES.PUBLIC_OPINION, score: 0 });
      },
    });
    this._shortcutController.addShortcut({
      group: 'failed_end_screens',
      field: 'stability_fail_screen',
      title: 'Stability Fail Screen',
      value: (e) => {
        this.setEndScreen({ type: SCORE_METRIC_TYPES.STABILITY, score: 0 });
      },
    });
    this._shortcutController.addShortcut({
      group: 'failed_end_screens',
      field: 'credibility_fail_screen',
      title: 'Credibility Fail Screen',
      value: (e) => {
        this.setEndScreen({ type: SCORE_METRIC_TYPES.CREDIBILITY, score: 0 });
      },
    });
    this._shortcutController.addShortcut({
      group: 'failed_end_screens',
      field: 'negotiation_fail_screen',
      title: 'Negotiation Fail Screen',
      value: (e) => {
        this.setEndScreen({ type: SCORE_METRIC_TYPES.NEGOTIATION, score: 0 });
      },
    });
  }

  setEndScreen(scoreData) {
    this._game._scores.resetScores();

    if (scoreData.type === 'multiple') {
      scoreData.data.forEach((score) => {
        this._game._scores.setScoreType({ type: score.type, score: score.score });
      });
    } else {
      this._game._scores.setScoreType({ type: scoreData.type, score: scoreData.score });
    }

    this._game.outroScene();
  }
}
